import AutoHeightImage from "react-native-auto-height-image";
import I18n from "i18n-js";
import React from "react";

import { Image, StyleSheet, Text, TouchableOpacity, View, SafeAreaView } from "react-native";
import { connect } from "react-redux";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

class AskScreen extends React.Component {
  state = {
    containerWidth: 0
  };

  handleCancelPress() {
    this.props.navigation.goBack();
  }

  handleContainerLayout({
    nativeEvent: {
      layout: { width }
    }
  }) {
    this.setState({
      containerWidth: width
    });
  }

  handleDependencyPress() {
    this.props.navigation.replace("dependencies", {
      patientId: this.props.navigation.state.params.patientId
    });
  }

  handlePatientPress() {
    this.props.navigation.replace("symptom", {
      patientId: this.props.navigation.state.params.patientId
    });
  }

  render() {
    const { themeColors } = this.props;
    const { containerWidth } = this.state;

    return (
      <View
        onLayout={e => this.handleContainerLayout(e)}
        style={[
          styles.container,
          {
            backgroundColor: themeColors.primary
          }
        ]}
      >
        <SafeAreaView>
          <TouchableOpacity
            onPress={() => this.handleCancelPress()}
            style={styles.cancelButton}
          >
            <Image
              source={require("../assets/icons/round_arrow_back_ios_white_18dp.png")}
            />
            <Text style={styles.cancelText}>{I18n.t("prixa.cancel")}</Text>
          </TouchableOpacity>
        </SafeAreaView>
        <View style={styles.illustrationContainer}>
          <AutoHeightImage
            source={require("../assets/illustrations/ask.png")}
            width={containerWidth - 120}
          />
        </View>
        <View style={styles.contentContainer}>
          <Text
            style={[
              styles.question,
              {
                color: themeColors.darkestPrimary
              }
            ]}
          >
            {I18n.t("prixa.intendedFor")}
          </Text>
          <View style={styles.actionsContainer}>
            <TouchableOpacity
             onPress={() => this.handlePatientPress()}
              style={[
                styles.dependencyButton,
                {
                  backgroundColor: themeColors.darkestPrimary
                }
              ]}
            >
              <Text style={styles.dependencyText}>
              {this.props.navigation.state.params.firstName}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
             onPress={() => this.handleDependencyPress()}
              style={styles.patientButton}
            >
              <Text style={styles.patientText}>
              {I18n.t("prixa.others")}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  actionsContainer: {
    flexDirection: "row",
    justifyContent: "space-between"
  },
  cancelButton: {
    alignItems: "center",
    flexDirection: "row",
    padding: 15,
    paddingVertical: 36
  },
  cancelText: {
    color: staticColors.white,
    fontSize: 16,
    marginStart: 15,

    ...fonts.bold
  },
  container: {
    flex: 1
  },
  contentContainer: {
    backgroundColor: staticColors.white,
    borderTopEndRadius: 40,
    borderTopStartRadius: 40,
    paddingHorizontal: 30,
    paddingVertical: 40
  },
  dependencyButton: {
    borderRadius: 20,
    paddingHorizontal: 30,
    paddingVertical: 10
  },
  dependencyText: {
    color: staticColors.white,
    fontSize: 16,

    ...fonts.bold
  },
  illustrationContainer: {
    alignItems: "center",
    flexGrow: 1,
    justifyContent: "center"
  },
  patientButton: {
    backgroundColor: staticColors.forestFern,
    borderRadius: 20,
    paddingHorizontal: 30,
    paddingVertical: 10
  },
  patientText: {
    color: staticColors.white,
    fontSize: 16,

    ...fonts.bold
  },
  question: {
    fontSize: 24,
    marginBottom: 30,
    textAlign: "center",

    ...fonts.regular
  }
});

export default connect(state => ({
  themeColors: state.themeColors
}))(AskScreen);
